import comm from "../assets/lib/comm";
import cache from "../assets/lib/cache";
import zone from "./zone";
import Vue from "vue";
import $store from "@/store";
class Device {
  constructor(vue) {
    this.name = "Device";
    this.source = 1;
    this.vue = vue;
  }
  /** 锁到家门锁 */
  async openDoor (deviceCode) {
    const result = await Vue.axios.request({
      url: "https://service.datatellit.com/open/suodaojia/opendoor?deviceCode="+deviceCode,
      method: 'get'
    })
    return result
  }

  // 打开门锁
  async openDoorLock() {
    const result = await Vue.axios.request({
      url: Vue._config.api.lockControl,
      method: "post",
      headers: {
        "Context-Type": "application/json",
        "X-Authorization": "70819c42-6787-497b-b331-f22d47bf3650", //固定
      },
      data: {
        deviceId: "AsmnOkcG5UU=",
        control: "OPEN",
      },
    });
    return result;
  }
  
  async getLockState(params) {
    const result = await Vue.axios.get(Vue._config.api.lockState, { params });
    return result;
  }
  getColor(color) {
    if (color === "white") {
      return "白色";
    } else if (color === "red") {
      return "红色";
    } else if (color === "green") {
      return "绿色";
    } else if (color === "blue") {
      return "蓝色";
    } else if (color === "yellow") {
      return "黄色";
    } else if (color === "deepskyblue") {
      return "青色";
    } else if (color === "color") {
      return "炫彩";
    } else if (color === "deeppink") {
      return "粉色";
    }
  }

  /*
   * 多个设备控制，传递类型及action
   */
  async batchControl(type, action, value = null, include) {
    // 批量控制，新版和老版本分开，将其分解为单个设备控制指令
    const devices = $store.state.devices;
    if (!devices || !devices.length || !devices[0].connected) {
      throw new Error("设备离线或不存在，请联系管理员");
    }
    // 生成控制日志，根据动作及设备相关信息
    const obj = this.generateBatchText(type[0], action, value);
    // 确定版本
    let { command, tp } = devices.length && devices[0].version > 1 ? this.generateBatchCommandV2(type, action, value, include) : this.generateBatchCommandV1(type, action, value);
    if (!command || !command.length) {
      throw new Error("未发现要控制的设备或指令");
    }
    // 会议室lora空调特殊控制
    let did = this._getController(null);
    let channel = 0;
    if (did[0] === "20002e001947333436383030" && type[0] === "aircon") {
      did = ["27002d001347343133363638"];
      command = this.generateLoraAirconCmd(action);
      channel = 2;
    }
    //
    try {
      // 发送控制命令
      const result = await this._sendCommand([
        {
          deviceid: did,
          args: command,
          logs: obj.logs,
          channel: channel,
        },
      ]);
      if (result && result.data && result.data.code === 1) {
        this.updateBatchDeviceState(tp, obj.state, include);
      } else {
        throw new Error("请求超时，请检查网络");
      }
    } catch (e) {
      throw e;
    }
  }

  generateLoraAirconCmd(action) {
    let command = [];
    const deiviceCmd = {
      cmd: {
        action: {
          open: {
            cmd: 81,
            dt: [0, 1],
            reg: 40002,
            len: 1,
          },
          close: {
            cmd: 81,
            dt: [0, 0],
            reg: 40002,
            len: 1,
          },
          cold: {
            cmd: 81,
            dt: [0, 3],
            reg: 40003,
            len: 1,
          },
          heat: {
            cmd: 81,
            dt: [0, 1],
            reg: 40003,
            len: 1,
          },
          lowspeed: {
            cmd: 81,
            dt: [0, 1],
            reg: 40005,
            len: 1,
          },
          middlespeed: {
            cmd: 81,
            dt: [0, 2],
            reg: 40005,
            len: 1,
          },
          fastspeed: {
            cmd: 81,
            dt: [0, 3],
            reg: 40005,
            len: 1,
          },
          openlock: {
            cmd: 81,
            dt: [0, 0],
            reg: 40034,
            len: 1,
          },
          closelock: {
            cmd: 81,
            dt: [0, 3],
            reg: 40034,
            len: 1,
          },
          select: {
            cmd: 80,
            reg: 40000,
            len: 7,
          },
        },
        cmd: {
          len: 1,
        },
      },
    };
    let actionCmd = deiviceCmd.cmd.action[action];
    let cmd1 = Object.assign({}, deiviceCmd.cmd.cmd, actionCmd, { nd: 185 }, { addr: 7 });
    let cmd2 = Object.assign({}, deiviceCmd.cmd.cmd, actionCmd, { nd: 185 }, { addr: 8 });
    command.push(cmd1);
    command.push(cmd2);
    return command;
  }

  /**
   * 教室灯控制
   * @param {*} device
   * @param {*} action
   * @param {*} value
   */
  async controlClassLight(device, action, select) {
    // 确定版本
    const devices = $store.state.devices.filter((d) => d.coreid === device.deviceId);
    if (!devices.length || !devices[0].connected) {
      throw new Error("设备离线或不存在，请联系管理员");
    }
    let km = parseInt(select, 2);
    const command = this.generateCommandV3(device, action, km);
    if (!command) {
      throw new Error("未发现要控制的设备或指令");
    }
    console.log(command);
    // 生成控制日志，根据动作及设备相关信息
    const obj = this.generateText(device, action, command);
    try {
      // 发送控制命令
      const result = await this._sendCommand([
        {
          deviceid: this._getController(device || null),
          args: [command],
          logs: obj.logs,
        },
      ]);
      if (result && result.data && result.data.code === 1) {
        // 更新状态(不需要主动状态更新:发送km，代表控制的灯，接收的km代表最终状态)
        // let findObj = $store.getters.getRemotes.find((f) => f.nd === device.nd);
        // if (findObj) {
        // findObj.km = km;
        // console.log(km);
        // $store.commit("SET_REMOTES", $store.getters.getRemotes);
        // }
      } else {
        throw new Error("请求超时，请检查网络");
      }
    } catch (e) {
      throw e;
    }
  }
  /**
   * 拼接命令
   * @param {*} device 设备
   * @param {*} actionKey 控制命令
   * @param {*} select 选中命令
   * @returns
   */
  generateCommandV3(device, actionKey, km) {
    try {
      let cmd = {};
      if (device) {
        if (device.cmd) {
          if (device.cmd.cmd) cmd = JSON.parse(device.cmd.cmd);
          if (device.cmd.action) {
            // 控制
            let action = JSON.parse(device.cmd.action);
            cmd["tag"] = action[actionKey].tag;
          }
        }
        if (device.nd) cmd["nd"] = device.nd;
        cmd["sid"] = device.sid;
        cmd["dt"] = [km];
      }
      return cmd;
    } catch (e) {
      console.warn(e);
      return {};
    }
  }
  /*
   * 单个设备控制，传递设备及动作
   */
  async singleControl(device, action, value = null) {
    // 确定版本
    const devices = $store.state.devices.filter((d) => d.coreid === device.deviceId);
    if (!devices.length || !devices[0].connected) {
      throw new Error("设备离线或不存在，请联系管理员");
    }
    let command = devices[0].version > 1 ? this.generateCommandV2(device, action, value) : this.generateCommandV1(device, action, value);
    if (!command) {
      throw new Error("未发现要控制的设备或指令");
    }
    // 生成控制日志，根据动作及设备相关信息
    const obj = this.generateText(device, action, value);
    // 会议室lora空调特殊控制
    let channel = 0;
    let did = this._getController(device || null);
    if (did[0] === "20002e001947333436383030" && device.devicetype && device.devicetype.key && device.devicetype.key === "aircon") {
      did = ["27002d001347343133363638"];
      command = this.generateLoraAirconCmd(action);
      channel = 2;
    }
    //
    try {
      // 发送控制命令
      const result = await this._sendCommand([
        {
          deviceid: did,
          args: Array.isArray(command) ? command : [command],
          logs: obj.logs,
          channel: channel,
        },
      ]);
      if (result && result.data && result.data.code === 1) {
        this.updateDeviceState(device, obj.state);
        // this.updateDeviceState(device, device.devicetype && device.devicetype.key === 'aircon' ? result.data.data : obj.state)
      } else {
        throw new Error("请求超时，请检查网络");
      }
    } catch (e) {
      throw e;
    }
  }

  generateBatchCommandV1(type, action, value) {
    const command = [];
    // 如果没有传入tp代表所有设备
    if (!type || type[0] === "all" || !type.length) {
      // 获取用户定义的所有设备，如果没有设置代表全部
      const all = $store.state.config;
      if (all) {
        type = all;
      } else {
        type = ["light", ...new Set($store.state.extDevices.map((ext) => ext.devicetype.key))];
      }
    }
    type = Array.isArray(type) ? type : [type];
    type.forEach((tp) => {
      if (tp === "sensor" || tp === "remote") return;
      // 区分灯具还是其他设备，
      if (tp === "light") {
        $store.state.lights.forEach((light) => {
          command.push(this.generateCommandV1(light, action, value));
        });
      } else {
        // 找到对应tp的设备，挨个放入
        $store.state.extDevices.forEach((ext) => {
          if (ext.devicetype.key === tp) {
            if (ext.devicetype.key === "switch") {
              if (tp === "spotlight" && ext.name.indexOf("射灯") > -1) {
                command.push(this.generateCommandV1(ext, action, value));
              } else if (tp === "humidifier" && ext.name === "加湿器") {
                command.push(this.generateCommandV1(ext, action, value));
              } else if (tp === "switch" && ext.name.indexOf("射灯") === -1) {
                command.push(this.generateCommandV1(ext, action, value));
              }
            } else {
              command.push(this.generateCommandV1(ext, action, value));
            }
          }
        });
      }
    });
    return { command: command, tp: type };
  }

  generateBatchCommandV2(type, action, value, include) {
    const command = [];
    // 如果没有传入tp代表所有设备
    if (!type || type[0] === "all" || !type.length) {
      // 获取用户定义的所有设备，如果没有设置代表全部
      const all = $store.state.config;
      if (all) {
        type = all.filter((d) => d.value).map((d) => d.key);
      } else {
        type = [
          "light",
          ...new Set(
            $store.state.extDevices.map((ext) => {
              // if (ext.devicetype.key !== 'airswitch') {
              return ext.devicetype.key;
              // }
            })
          ),
        ];
      }
    }
    type = Array.isArray(type) ? type : [type];
    type.forEach((tp) => {
      if (tp === "sensor") return;
      // 区分灯具还是其他设备，
      if (tp === "light") {
        $store.state.lights.forEach((light) => {
          // 处理包含的设备
          if (include) {
            if (include.includes(light.id)) {
              command.push(this.generateCommandV2(light, action, value));
            }
          } else {
            command.push(this.generateCommandV2(light, action, value));
          }
        });
      } else {
        // 找到对应tp的设备，挨个放入
        $store.state.extDevices.forEach((ext) => {
          if (include) {
            if (ext.devicetype.key === tp && include.includes(ext.id)) {
              if (ext.devicetype.key === "switch") {
                if (tp === "spotlight" && ext.name.indexOf("射灯") > -1) {
                  command.push(this.generateCommandV2(ext, action, value));
                } else if (tp === "humidifier" && ext.name === "加湿器") {
                  command.push(this.generateCommandV2(ext, action, value));
                } else if (tp === "switch" && ext.name.indexOf("射灯") === -1) {
                  command.push(this.generateCommandV2(ext, action, value));
                }
              } else {
                command.push(this.generateCommandV2(ext, action, value));
              }
            }
          } else {
            if (ext.devicetype.key === tp) {
              if (ext.devicetype.key === "switch") {
                if (tp === "spotlight" && ext.name.indexOf("射灯") > -1) {
                  command.push(this.generateCommandV2(ext, action, value));
                } else if (tp === "humidifier" && ext.name === "加湿器") {
                  command.push(this.generateCommandV2(ext, action, value));
                } else if (tp === "switch" && ext.name.indexOf("射灯") === -1) {
                  command.push(this.generateCommandV2(ext, action, value));
                }
              } else {
                command.push(this.generateCommandV2(ext, action, value));
              }
            }
          }
        });
      }
    });
    return { command: command, tp: type };
  }

  generateText(device, action, value = null) {
    let log = "";
    let state = {};
    switch (action) {
      case "open":
        log = "打开" + device.name;
        state = { state: 1, color: "white", air: 2 };
        break;
      case "close":
        log = "关闭" + device.name;
        state.state = device.devicetype && device.devicetype.key === "curtain" ? 2 : 0;
        break;
      case "paused":
        log = "停止" + device.name;
        state.state = 0;
        break;
      case "toggle":
        log = "切换" + device.name;
        break;
      case "add":
        log = device.name + "增加风量";
        state.air = (device.state && device.state.air + 1) || 2;
        state.air = state.air > 3 ? 3 : state.air;
        break;
      case "less":
        log = device.name + "减小风量";
        state.air = (device.state && device.state.air - 1) || 0;
        state.air = state.air < 0 ? 0 : state.air;
        break;
      case "tt":
        log = `调节${device.name}温度为${value}%`;
        state.tt = value;
        break;
      case "ttadd":
        log = device.name + "增加温度";
        state.tt = (device.state && device.state.tt + 1) || 17;
        state.tt = state.tt > 30 ? 30 : state.tt;
        break;
      case "ttless":
        log = device.name + "减小温度";
        state.tt = (device.state && device.state.tt - 1) || 16;
        state.tt = state.tt < 16 ? 16 : state.tt;
        break;
      case "low":
        log = device.name + "低风模式";
        state = { state: 1, air: 1 };
        break;
      case "high":
        log = device.name + "高风模式";
        state = { state: 1, air: 3 };
        break;
      case "medium":
        log = device.name + "中风模式";
        state = { state: 1, air: 2 };
        break;
      case "warm":
        log = device.name + "制热";
        state.mode = 1;
        break;
      case "cool":
        log = device.name + "制冷";
        state.mode = 0;
        break;
      case "br":
        log = `调节${device.name}亮度为${value}%`;
        state.brightness = value;
        break;
      case "cct":
        log = `调节${device.name}色温为${value}K`;
        state.cct = value;
        break;
      case "filter":
        log = `调节${device.name}特效为${value}`;
        state.filter = value;
        break;
      case "red":
      case "green":
      case "blue":
      case "deeppink":
      case "white":
      case "deepskyblue":
      case "yellow":
      case "color":
        log = `调节${device.name}的颜色为${action}`;
        state = { state: 1, color: action };
        break;
      default:
        log = `${device.name}=>未识别的控制命令=>${action}`;
    }
    return { logs: this._appendLogs(log, device.devicetype && { cmd: 8, value: action }), state: state };
  }

  translateType(type) {
    switch (type) {
      case "light":
        return "灯具";
      case "aircon":
        return "空调";
      case "airpure":
        return "新风";
      case "curtain":
        return "窗帘";
      case "humidifier":
        return "加湿器";
      case "spotlight":
        return "射灯";
      case "switch":
        return "智能插座";
      case "colorbar":
        return "灯带";
      case "all":
        return "全部设备";
      case "fan":
        return "风扇";
    }
  }

  generateBatchText(type, action, value = null) {
    // 根据type分析出设备范围
    let log = "";
    let state = {};
    let name = this.translateType(type);
    switch (action) {
      case "open":
        log = `打开${name}`;
        state = { state: 1, color: "white", air: 2 };
        break;
      case "close":
        log = `关闭${name}`;
        state.state = type === "curtain" ? 2 : 0;
        break;
      case "paused":
        log = `停止${name}`;
        state.state = 0;
        break;
      case "toggle":
        log = `切换${name}`;
        break;
      case "tt":
        log = `调节${name}温度为${value}%`;
        state.tt = value;
        break;
      case "low":
        log = `${name}低风模式`;
        state = { state: 1, air: 1 };
        break;
      case "high":
        log = `${name}高风模式`;
        state = { state: 1, air: 3 };
        break;
      case "medium":
        log = `${name}中风模式`;
        state = { state: 1, air: 2 };
        break;
      case "warm":
        log = `${name}制热`;
        state = { state: 1, mode: 1 };
        break;
      case "cool":
        log = `${name}制冷`;
        state = { state: 1, mode: 0 };
        break;
      case "br":
        log = `调节${name}亮度为${value}%`;
        state.brightness = value;
        break;
      case "cct":
        log = `调节${name}色温为${value}K`;
        state.cct = value;
        break;
      case "filter":
        log = `调节${name}特效为${value}`;
        state.filter = value;
        break;
      case "red":
      case "green":
      case "blue":
      case "deeppink":
      case "white":
      case "deepskyblue":
      case "yellow":
      case "color":
        log = `调节${name}的颜色为${action}`;
        state = { state: 1, color: action };
        break;
      default:
        log = `${name}=>未识别的控制命令=>${action}`;
    }
    return { logs: this._appendLogs(log, type.length === 0 && { cmd: 9, value: state.state }), state: state };
  }

  generateCommand(device, action, value = null) {
    try {
      // 生成控制命令
      let isSanXK = device.cmd.action.indexOf("selectA") > -1;
      if (isSanXK && action === "select") {
        let actionCmd = JSON.parse(device.cmd.action);
        let selectA = actionCmd.selectA;
        let selectB = actionCmd.selectB;
        let selectC = actionCmd.selectC;
        let selectD = actionCmd.selectD;
        if (!selectA || !selectB || !selectC || !selectD) {
          throw new Error("指定设备不支持此动作");
        }
        let cmdA = Object.assign({}, JSON.parse(device.cmd.cmd), selectA, { nd: device.nd, addr: device.sid });
        let cmdB = Object.assign({}, JSON.parse(device.cmd.cmd), selectB, { nd: device.nd, addr: device.sid });
        let cmdC = Object.assign({}, JSON.parse(device.cmd.cmd), selectC, { nd: device.nd, addr: device.sid });
        let cmdD = Object.assign({}, JSON.parse(device.cmd.cmd), selectD, { nd: device.nd, addr: device.sid });
        return [cmdA, cmdB, cmdC, cmdD];
      } else {
        let actionCmd = JSON.parse(device.cmd.action)[action];
        if (!actionCmd) {
          throw new Error("指定设备不支持此动作");
        }
        if (JSON.stringify(actionCmd).indexOf(`$${action}`) > -1) {
          actionCmd = JSON.parse(JSON.stringify(actionCmd).replace(`"$${action}"`, value));
        }
        let cmd = Object.assign({}, JSON.parse(device.cmd.cmd), actionCmd, { nd: device.nd });
        if (device.sid) {
          if (device.devicetype && (device.devicetype.key === "airswitch" || device.devicetype.key === "lora_aircon")) {
            Object.assign(cmd, { addr: device.sid });
          } else {
            Object.assign(cmd, { sid: device.sid });
          }
          // lora 空调调温
          if (device.devicetype && device.devicetype.key === "lora_aircon" && action === "temp") {
            const d1 = Math.floor((value * 10) / 256);
            const d2 = (value * 10) % 256;
            Object.assign(cmd, { dt: [d1, d2] });
          }
        }
        return cmd;
      }
    } catch (e) {
      console.log(e);
      throw new Error("设备命令格式异常");
    }
  }

  generateCommandV1(device, action, value = null) {
    let cmd = this.generateCommand(device, action, value);
    // 如果是灯，需要添加是否启用继电器
    if (!device.devicetype) {
      if (device.sid && $store.state.zone.relay) {
        Object.assign(cmd, { nd: 255, sid: device.sid });
      } else {
        // 软控特殊处理，不带sid
        delete cmd.sid;
      }
    }
    return cmd;
  }

  generateCommandV2(device, action, value = null) {
    let cmd = this.generateCommand(device, action, value);
    // 如果是灯，需要添加是否启用继电器
    // if (!device.devicetype) {
    //   !$store.state.zone.relay && Object.assign(cmd, { hwsw: 0 })
    // }
    return cmd;
  }

  updateDeviceState(device, state) {
    // 根据设备及其操作，更新store中的数据缓存
    $store.commit("UPDATE_DEVICE_BY_DEVICE", { device: device, state: state });
  }

  updateBatchDeviceState(type, state, include) {
    $store.commit("UPDATE_DEVICES_BY_TYPE", { type: type, state: state, include });
  }

  async updateDeviceInfo(device) {
    // 更新设备信息
    try {
      const url = device.tp === "light" ? Vue._config.api.nodes : Vue._config.api.extDevices;
      Vue._logger.debugger(url);
      const result = await Vue.axios.put(`${url}/${device.id}`, device);
      if (result.data.code === 1) {
        return result.data;
      } else {
        throw new Error("保存失败");
      }
    } catch (e) {
      throw e;
    }
  }

  _appendLogs(name, obj) {
    return Object.assign({ detail: name }, obj || {}, {
      userId: cache.getSession("dtit_user").id,
      zoneId: $store.state.zone.id,
      logtype: 1,
      logfrom: this.source,
    });
  }

  _getController(obj) {
    if (!obj) {
      // 这个区域下的控制器生效
      return $store.state.devices.map((c) => c.coreid) || null;
    } else {
      // 处理多控制器的
      let light = $store.state.lightsOrign.filter((item) => item.device_no === obj.device_no);
      let ext = $store.state.extDevicesOrign.filter((item) => {
        if (item.devicetype.key === "airswitch") {
          return item.sid === obj.sid;
        } else {
          return item.nd === obj.nd;
        }
      });
      let all = light.concat(ext).map((item) => item.deviceId || item.coreid);
      // 去重
      all = [...new Set(all)];
      return all;
    }
  }

  async _sendCommand(args, logs = null) {
    if (!args.length) {
      throw new Error("未找到网关设备，请联系管理员！");
    } else if (args.length === 1 && typeof args[0].deviceid === "object") {
      args = args[0];
    }
    if (args.logs.value !== "select") {
      var loading = comm.showLoading("#app", "设备控制中，请稍后...");
    }
    const body = logs ? Object.assign({ data: args, logs: logs }) : { data: args };
    // 发送
    try {
      Vue._logger.debugger(Vue._config.api.control);
      const result = await Vue.axios.post(Vue._config.api.control, body);
      Vue._logger.debugger(result);
      // 添加操作反馈
      return result;
    } catch (e) {
      throw e;
    } finally {
      // 特殊处理排除空开
      if (body.data.logs.value !== "select") {
        setTimeout(() => {
          comm.closeLoading(loading);
        }, 300);
      }
    }
  }

  // 其他外部设备请求
  async otherExtDeviceControl(params) {
    try {
      Vue._logger.debugger(Vue._config.api.otherControl);
      const result = await Vue.axios.get(Vue._config.api.otherControl, {
        params,
      });
      Vue._logger.debugger(result);
      // 页面状态同步
      $store.state.otherExtDevices.forEach((item) => {
        if (item.unique === params.deviceId) {
          let state = params.cmdParam === 1 ? 1 : 0;
          item.state.state = state;
        }
      });
      $store.commit("SET_OTHEREXT", $store.state.otherExtDevices);

      // // 获取其他外部其他设备
      // let otherExtState = await zone.getOtherExtState(params.deviceId)
      // // 更新外部设备列表的状态
      // zone.upadataOtherExtState($store.state.otherExtDevices, otherExtState)
      return result;
    } catch (e) {
      throw e;
    }
  }
}

export default new Device();
